// extracted by mini-css-extract-plugin
module.exports = {"signIn":"styles_signIn__3VfvH","wrapper":"styles_wrapper__lhicA","header":"styles_header__KFDOe","social":"styles_social__UbIYs"};